import { Component, HostListener, ChangeDetectorRef } from '@angular/core';

import { Router, NavigationEnd } from '@angular/router';

import { Angulartics2Piwik } from 'angulartics2/piwik';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'braungard';

  headerHeight = 150;
  logoHeight = 150;

  left = -100;

  @HostListener('window:scroll', ['$event'])
  onScroll(event) {
    if (window.scrollY === 0) {

        this.headerHeight = 150;
        this.logoHeight = 150;
    }
    else if (window.scrollY < (150 - 36)) {

      this.headerHeight = 150 - window.scrollY;
      if(window.scrollY > 64 ) {
        this.logoHeight = 150 - ((window.scrollY - 64) / 50) * 86;
      }
      else{
        this.logoHeight = 150;
      }
    }
    else {

      this.headerHeight = 36;
      this.logoHeight = 64;
    }
  }

  ngAfterViewInit(){
    this.left = 0;
    this.cdr.detectChanges()
  }
  constructor(private router: Router, private cdr: ChangeDetectorRef, private angulartics2Piwik: Angulartics2Piwik){
     // override the route reuse strategy
     this.router.routeReuseStrategy.shouldReuseRoute = function(){
        return false;
     }

     this.router.events.subscribe((evt) => {
        if (evt instanceof NavigationEnd) {
           // trick the Router into believing it's last link wasn't previously loaded
           this.router.navigated = false;
           // if you need to scroll back to top, here is the right place
           window.scrollTo(0, 0);
        }
    });

}
}



// WEBPACK FOOTER //
// /home/leonhard/Projekte/braungardt/angular/src/app/app.component.ts